import { CheckBox } from "@mui/icons-material";
import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { useSocket } from "common/hooks/useSocket";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "common/components/ConfirmDialog";

type ConfirmReplayProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  switchPlayers: boolean;
  setSwitchPlayers: (value: boolean) => void;
};

const ConfirmReplay = (props: ConfirmReplayProps) => {
  const { open, setOpen, switchPlayers, setSwitchPlayers } = props;
  const { t } = useTranslation();
  const socket = useSocket();
  const navigate = useNavigate();

  return (
    <ConfirmDialog
      open={open}
      onClose={() => setOpen(false)}
      title={t("Rejouer")}
      description={t(
        "Rejouer ramènera tout le monde dans la salle d'attente. Veux-tu continuer ?",
      )}
      onCancel={() => setOpen(false)}
      onConfirm={() => {
        socket.emit("send-replay", switchPlayers);
      }}
      cancelLabel={t("Annuler")}
      confirmLabel={t("Rejouer")}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={switchPlayers}
            onChange={(val) => setSwitchPlayers(val.target.checked)}
          />
        }
        label={t(
          "Inverser les camps des joueurs.",
        )}
        sx={{ marginTop: "1rem" }}
      />
    </ConfirmDialog>
  );
};

export default ConfirmReplay;
